import { IvrUser } from "../../../../Models/User";
import { useGem } from "../../../../Utils/UseGem";

const useGetIvrUsers = () => {
  const { res, loading } = useGem<IvrUser[]>({ url: "Legacy/V0/ivr/users" });
  return { res: res?.payload, loading };
};

export default useGetIvrUsers;
